<template>
  <v-data-table
    v-model="selected"
    :show-select="totaleClienti > 0"
    item-key="_id"
    :headers="headers"
    :items="clientiSorted"
    :options.sync="options"
    :loading="loading"
    class="elevation-1"
    :disable-sort="true"
    :footer-props="{
      itemsPerPageOptions: [5, 10, 15, 50, 100]
    }"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    show-expand
    dense
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Seleziona i clienti da fatturare</v-toolbar-title>
        <v-btn class = "ml-5" small color="success" @click.stop="onAggiungiTutti">Aggiungi tutti</v-btn>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>  
<!--     <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template> -->
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="clientiSelected">
        <v-tabs dense v-model="tab[item._id]">
          <v-tab>Spese in fattura</v-tab>
          <v-tab>Info bancarie</v-tab>
          <v-tab class="clientiSelected">Recapiti{{item.name}}</v-tab>          
        </v-tabs>
        <v-tabs-items v-model="tab[item._id]">
          <v-tab-item>
          </v-tab-item>
          <v-tab-item>
          </v-tab-item>
          <v-tab-item>
            <recapiti :recapiti="item.recapiti" @update-address="updateAddress" @new-address="newAddress"/>
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>    
  </v-data-table>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import Recapiti from '@/views/clienti/elementi/recapiti'
  import clienti from '@/services/clientiService.js'
  
  export default {
    props: {
      idsClienti: Array
    },
    components: {
      Recapiti
    },
    data () {
      return {
        totaleClienti: 0,
        clienti: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Codice', value: 'codice', align: 'start' },
          { text: 'Ragione sociale', value: 'ragioneSociale' },
          { text: 'Partita Iva', value: 'amministrativi.partitaIva' },
          { text: 'Indirizzo', value: 'c_indirizzo' },
          { text: 'Titolare', value: 'c_titolare' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: []
      }
    },
    computed: {
      refreshList() {
        return this.$store.getters['clienti/refresh']
      },
      clientiSorted() {
        const els = this.clienti
        const elSorted = els.sort(dynamicSortMultiple('ragioneSociale'))
        return elSorted
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      async idsClienti(value) {
        // if (value) {
          await this.getDataFromApi(value)
        // }
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('clienti/CLEAR_REFRESH')
        }
      },
      selected(value) {
        const ids = value.map(x => x.codice)
        this.$emit('selezione', ids)
      }
    },
    async mounted () {
      await this.getDataFromApi()
    },
    methods: {
      onAggiungiTutti() {
        this.selected = [...this.clienti]
      },      
      async onRicerca(filtri) {
        this.filtri = filtri
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          if (this.idsClienti.length === 0) {
            this.clienti = []
            this.totaleClienti = 0
            return
          }
          this.loading = true
          this.options.allRecords = true
          // const data = await clienti.getFilteredCustomers(this.filtri, this.options, 'v3')
          const data = await clienti.getClientiByIds(this.idsClienti)
          // this.clientiRaw = data && data.total_rows > 0 ? data.rows : []
          this.clienti = this.datiVisualizzazione(data)
          this.totaleClienti = data.length
          // TODO: Su impostazioni? Se abilitato: "nessuna selezione = tutte le selezioni"
          // this.$emit('selezione', this.idsClienti)
        } catch(err) {
          this.clienti = []
          this.totaleClienti = 0
        } finally {
          this.loading = false
          this.annullaSelezione()
        }
      },
      datiVisualizzazione(clienti) {
        const elaborati = clienti.map(el => {
          const recapito = el.recapiti && el.recapiti.length > 0 ? el.recapiti.find(x => x.tipo.codice === 'principale') : null
          const indirizzo = recapito ? `${recapito.indirizzo}, ${recapito.localita} ${recapito.cap} - ${recapito.provincia}` : ''
          const contatto = el.contatti && el.contatti.length > 0 ? el.contatti.find(x => x.tipo === 'titolare') : null
          let titolare = ''
          if (contatto) {
            titolare = `${contatto.nome} ${contatto.cognome}`
            if (contatto.cellulare) {
              titolare += ` - cell: ${contatto.cellulare}`
            }
            if (contatto.email) {
              titolare += ` - email: ${contatto.email}`
            }            
          }
          return { ...el, c_recapito: recapito, c_indirizzo: indirizzo, c_contatto: contatto, c_titolare: titolare }
        }) 
        return elaborati
      },
      newAddress(idCliente, address) {

      },
      updateAddress(idCliente, address) {

      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }      
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
  td.clientiSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>